// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Caml_splice_call from "rescript/lib/es6/caml_splice_call.js";
import * as Datadog$LiveRoom from "../bindings/Datadog.bs.js";

var makeErr = (function(message) {
        return new Error(message)
    });

function log(extraOpt, err, severityOpt, message) {
  var extra = extraOpt !== undefined ? Caml_option.valFromOption(extraOpt) : ({});
  var severity = severityOpt !== undefined ? severityOpt : "Error";
  if (!Datadog$LiveRoom.isEnabled(undefined)) {
    if (severity === "Info" || severity === "Log") {
      Caml_splice_call.spliceApply(console.log, [Belt_Array.concat([message], Js_dict.values(extra))]);
    } else {
      Caml_splice_call.spliceApply(console.error, [Belt_Array.concat([message], Js_dict.values(extra))]);
    }
    return ;
  }
  var extra$1 = Js_dict.fromArray(Belt_Array.concat([[
              "message",
              message
            ]], Js_dict.entries(extra)));
  if (severity === "Error") {
    return Datadog$LiveRoom.Logger.warn(message, Caml_option.some(extra$1), Caml_option.some(Belt_Option.getWithDefault(err, makeErr(message))), undefined);
  } else if (severity === "Info") {
    return Datadog$LiveRoom.Logger.info(message, Caml_option.some(extra$1), err, undefined);
  } else if (severity === "Warn") {
    return Datadog$LiveRoom.Logger.warn(message, Caml_option.some(extra$1), err, undefined);
  } else {
    return Datadog$LiveRoom.Logger.debug(message, Caml_option.some(extra$1), err, undefined);
  }
}

export {
  makeErr ,
  log ,
}
/* Datadog-LiveRoom Not a pure module */
